import { render, staticRenderFns } from "./UIPostTickerList.vue?vue&type=template&id=520f378e"
import script from "./UIPostTickerList.vue?vue&type=script&lang=js"
export * from "./UIPostTickerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIPostTickerCardSkeleton: require('/skade-pwa/components/ui/atom/skeleton/UIPostTickerCardSkeleton.vue').default})
